import * as angular from 'angular';

(function () {
    'use strict';

    var ONLINE_DOWNLOAD_PAGES = {
        DOWNLOADS: 'https://www.prisma-capacity.eu/downloads/'
    };

    /**
     * @ngdoc constant
     * @name ONLINE_DOWNLOAD_PAGES
     * @memberof app
     * @memberof app
     *
     * @description
     * Links to prisma download pages
     */
    angular
        .module('app')
        .constant('ONLINE_DOWNLOAD_PAGES', ONLINE_DOWNLOAD_PAGES);
})();
